<template>
  <div
    class="absolute lg:sticky top-0 min-w-[300px] lg:w-[230px] xl:w-[300px] px-3 2xl:px-6 bg-white border-t-4 scrollable-content border-pagebg py-3 overflow-y-auto pb-20 shadow-lg"
  >
    <nav
      class="flex flex-col text-sm lg:text-xs xl:text-sm 2xl:text-sm font-medium"
    >
      <div class="my-6 lg:hidden">
        <RouterLink to="/">
          <img class="max-w-[130px]" src="@/assets/img/logo_oneclick1.svg" />
        </RouterLink>
      </div>
      <div class="items-center flex space-x-3 lg:hidden">
        <p class="text-md font-medium">
          Hello {{ authStore.user?.first_name }},
        </p>
        <div id="dropdown" class="flex space-x-3 relative cursor-pointer my-4">
          <div
            class="rounded-full bg-primary w-9 h-9 flex items-center justify-center pointer-events-none"
          >
            <span
              class="contents text-white text-center block text-base font-semibold"
            >
              {{ authStore.user?.getInitials() }}
            </span>
          </div>
        </div>
      </div>

      <p class="lg:hidden uppercase font-semibold text-primary text-sm">
        {{ $t("nav.account") }}
      </p>
      <div class="lg:hidden">
        <RouterLink @click="close" to="/"
          ><p class="text-md mt-2 hover:text-primary hover:underline">
            {{ $t("nav.home") }}
          </p></RouterLink
        >
        <RouterLink
          @click="close"
          :to="{ name: 'my-profile', params: { id: authStore.user?.id } }"
        >
          <p class="text-md my-2 hover:text-primary hover:underline">
            {{ $t("nav.my-profile") }}
          </p>
        </RouterLink>
      </div>
      <template v-if="authStore.accountPermissions.allowedAny([KPN.SITEADMIN_ENABLED])">
        <div class="flex items-center justify-between mt-2">
          <p class="uppercase font-semibold text-primary text-sm">
            {{ $t("nav.site_admin") }}
          </p>
          <div @click="toggleSiteAdmin" :class="{ 'rotate-180': isSiteAdminOpen }">
            <IconOpenSection />
          </div>
        </div>
        <div v-show="isSiteAdminOpen">
          <RouterLink v-if="authStore.accountPermissions.allowedAll([KPN.BRANCHES_ENABLED])"
            @click="close"
            :to="{ name: 'branches-listing' }">
            <p :class="routeName === 'branches-listing'
                  ? 'active-menu-item text-primary'
                  : 'text-text'"
              class="flex items-center hover:text-primary item-list-custom mt-3"
            >
              <span class="rounded-full w-5 h-5 block mr-3 item-list-circle"></span>
              <span>Branches</span>
            </p>
          </RouterLink>
          <RouterLink v-if="authStore.accountPermissions.allowedAll([KPN.BUSINESSLINES_ENABLED])"
            @click="close"
            :to="{ name: 'bussiness-lines-listing' }">
            <p :class="routeName === 'bussiness-lines-listing'
                  ? 'active-menu-item text-primary'
                  : 'text-text'"
              class="flex items-center hover:text-primary item-list-custom mt-3"
            >
              <span class="rounded-full w-5 h-5 block mr-3 item-list-circle"></span>
              <span>{{ $t("nav.site-admin-business-lines") }}</span>
            </p>
          </RouterLink>
          <RouterLink
            v-if="
              authStore.accountPermissions.allowedAny([
                KPN.CLIENTPERMISSIONPAGES_ENABLED,
              ])
            "
            @click="close"
            :to="{ name: 'client-permission-and-pages' }"
          >
            <p
              :class="
                routeName === 'client-permission-and-pages'
                  ? 'active-menu-item text-primary'
                  : 'text-text'
              "
              class="flex items-center hover:text-primary item-list-custom mt-3"
            >
              <span
                class="rounded-full w-5 h-5 block mr-3 item-list-circle"
              ></span>
              <span>{{ $t("nav.client-permission-and-pages") }}</span>
            </p>
          </RouterLink>
          <RouterLink
            v-if="authStore.accountPermissions.allowedAny([KPN.FORMS_ENABLED])"
            @click="close"
            :to="{ name: 'forms-listing' }"
          >
            <p
              :class="
                routeName === 'forms-listing'
                  ? 'active-menu-item text-primary'
                  : 'text-text'
              "
              class="flex items-center hover:text-primary item-list-custom mt-3"
            >
              <span
                class="rounded-full w-5 h-5 block mr-3 item-list-circle"
              ></span>
              <span>{{ $t("nav.site-admin-forms") }}</span>
            </p>
          </RouterLink>
          <RouterLink
            v-if="
              authStore.accountPermissions.allowedAny([
                KPN.JSONRESOURCES_ENABLED,
              ])
            "
            @click="close"
            :to="{ name: 'resources-listing' }"
          >
            <p
              :class="
                routeName === 'resources-listing'
                  ? 'active-menu-item text-primary'
                  : 'text-text'
              "
              class="flex items-center hover:text-primary item-list-custom mt-3"
            >
              <span
                class="rounded-full w-5 h-5 block mr-3 item-list-circle"
              ></span>
              <span>{{ $t("nav.resources") }}</span>
            </p>
          </RouterLink>
          <RouterLink
            v-if="
              authStore.accountPermissions.allowedAny([
                KPN.KLGPERMISSIONPAGES_ENABLED,
              ])
            "
            @click="close"
            :to="{ name: 'klg-permission-and-pages' }"
          >
            <p
              :class="
                routeName === 'klg-permission-and-pages'
                  ? 'active-menu-item text-primary'
                  : 'text-text'
              "
              class="flex items-center hover:text-primary item-list-custom mt-3"
            >
              <span
                class="rounded-full w-5 h-5 block mr-3 item-list-circle"
              ></span>
              <span>{{ $t("nav.klg-permission-and-pages") }}</span>
            </p>
          </RouterLink>
          <RouterLink
            v-if="
              authStore.accountPermissions.allowedAny([
                KPN.KLGPERMISSIONPAGES_ENABLED,
              ])
            "
            @click="close"
            :to="{ name: 'klg-permissions-import' }"
          >
            <p
              :class="
                routeName === 'klg-permissions-import'
                  ? 'active-menu-item text-primary'
                  : 'text-text'
              "
              class="flex items-center hover:text-primary item-list-custom mt-3"
            >
              <span
                class="rounded-full w-5 h-5 block mr-3 item-list-circle"
              ></span>
              <span>{{ $t("nav.klg-permissions-import") }}</span>
            </p>
          </RouterLink>
          <RouterLink
            v-if="
              authStore.accountPermissions.allowedAny([
                KPN.MAINTENANCES_ENABLED,
              ])
            "
            @click="close"
            :to="{ name: 'maintenances' }"
          >
            <p
              :class="
                routeName === 'maintenance'
                  ? 'active-menu-item text-primary'
                  : 'text-text'
              "
              class="flex items-center hover:text-primary item-list-custom mt-3"
            >
              <span
                class="rounded-full w-5 h-5 block mr-3 item-list-circle"
              ></span>
              <span>{{ $t("nav.maintenance") }}</span>
            </p>
          </RouterLink>
          <RouterLink
            v-if="
              authStore.accountPermissions.allowedAny([
                KPN.OPTIONVALUES_ENABLED,
              ])
            "
            @click="close"
            :to="{ name: 'option-categories-listing' }"
          >
            <p
              :class="
                routeName === 'option-categories-listing'
                  ? 'active-menu-item text-primary'
                  : 'text-text'
              "
              class="flex items-center hover:text-primary item-list-custom mt-3"
            >
              <span
                class="rounded-full w-5 h-5 block mr-3 item-list-circle"
              ></span>
              <span>{{ $t("nav.site-admin-option-categories") }}</span>
            </p>
          </RouterLink>
          <RouterLink
              v-if="
              authStore.accountPermissions.allowedAny([
                KPN.WEBMAILDOMAINS_ENABLED,
              ])
            "
              @click="close"
              :to="{ name: 'pages' }"
          >
            <p
                :class="
                routeName === 'pages'
                  ? 'active-menu-item text-primary'
                  : 'text-text'
              "
                class="flex items-center hover:text-primary item-list-custom mt-3"
            >
              <span
                  class="rounded-full w-5 h-5 block mr-3 item-list-circle"
              ></span>
              <span>{{ $t("nav.pages") }}</span>
            </p>
          </RouterLink>
        </div>
      </template>
      <template v-if="authStore.accountPermissions.allowedAny([KPN.SITECONFIGURATION_ENABLED])">
        <div class="flex items-center justify-between mt-6">
          <p class="uppercase font-semibold text-primary text-sm">
            {{ $t("nav.site_configuration") }}
          </p>
          <div @click="toggleSiteConfiguration" :class="{ 'rotate-180': isSiteConfigurationOpen }">
            <IconOpenSection />
          </div>
        </div>
        <div v-show="isSiteConfigurationOpen">
          <RouterLink
            v-if="
              authStore.accountPermissions.allowedAny([
                KPN.ACCEPTEDEMAILDOMAINS_ENABLED,
              ])
            "
            @click="close"
            :to="{ name: 'emails' }"
          >
            <p
              :class="
                routeName === 'emails'
                  ? 'active-menu-item text-primary'
                  : 'text-text'
              "
              class="flex items-center hover:text-primary item-list-custom mt-3"
            >
              <span
                class="rounded-full w-5 h-5 block mr-3 item-list-circle"
              ></span>
              <span>{{ $t("nav.accepted-email-domains") }}</span>
            </p>
          </RouterLink>
          <RouterLink
            v-if="
              authStore.accountPermissions.allowedAny([
                KPN.ALLOWEDREGISTERDOMAIN_ENABLED,
              ])
            "
            @click="close"
            :to="{ name: 'allowed-register-domains' }"
          >
            <p
              :class="
                routeName === 'allowed-register-domains'
                  ? 'active-menu-item text-primary'
                  : 'text-text'
              "
              class="flex items-center hover:text-primary item-list-custom mt-3"
            >
              <span
                class="rounded-full w-5 h-5 block mr-3 item-list-circle"
              ></span>
              <span>{{ $t("nav.allowed-register-domains") }}</span>
            </p>
          </RouterLink>
          <RouterLink
            v-if="
              authStore.accountPermissions.allowedAny([KPN.APISOURCES_ENABLED])
            "
            @click="close"
            :to="{ name: 'api-sources' }"
          >
            <p
              :class="
                routeName === 'api-sources'
                  ? 'active-menu-item text-primary'
                  : 'text-text'
              "
              class="flex items-center hover:text-primary item-list-custom mt-3"
            >
              <span
                class="rounded-full w-5 h-5 block mr-3 item-list-circle"
              ></span>
              <span>{{ $t("nav.api_sources") }}</span>
            </p>
          </RouterLink>
          <RouterLink
            v-if="
              authStore.accountPermissions.allowedAny([KPN.APISTATUSES_ENABLED])
            "
            @click="close"
            :to="{ name: 'api-statuses' }"
          >
            <p
              :class="
                routeName === 'api-statuses'
                  ? 'active-menu-item text-primary'
                  : 'text-text'
              "
              class="flex items-center hover:text-primary item-list-custom mt-3"
            >
              <span
                class="rounded-full w-5 h-5 block mr-3 item-list-circle"
              ></span>
              <span>{{ $t("nav.api_statuses") }}</span>
            </p>
          </RouterLink>
          <RouterLink
            v-if="
              authStore.accountPermissions.allowedAny([KPN.APPSTATUSES_ENABLED])
            "
            @click="close"
            :to="{ name: 'app-statuses' }"
          >
            <p
              :class="
                routeName === 'app-statuses'
                  ? 'active-menu-item text-primary'
                  : 'text-text'
              "
              class="flex items-center hover:text-primary item-list-custom mt-3"
            >
              <span
                class="rounded-full w-5 h-5 block mr-3 item-list-circle"
              ></span>
              <span>{{ $t("nav.app_statuses") }}</span>
            </p>
          </RouterLink>
          <RouterLink
            v-if="
              authStore.accountPermissions.allowedAny([
                KPN.AUTHORIZEDEMAILS_ENABLED,
              ])
            "
            @click="close"
            :to="{ name: 'authorized-emails' }"
          >
            <p
              :class="
                routeName === 'authorized-emails'
                  ? 'active-menu-item text-primary'
                  : 'text-text'
              "
              class="flex items-center hover:text-primary item-list-custom mt-3"
            >
              <span
                class="rounded-full w-5 h-5 block mr-3 item-list-circle"
              ></span>
              <span>{{ $t("nav.authorized_emails") }}</span>
            </p>
          </RouterLink>
          <RouterLink
            v-if="
              authStore.accountPermissions.allowedAny([
                KPN.CONTRACTMANAGERS_ENABLED,
              ])
            "
            @click="close"
            :to="{ name: 'contract-managers' }"
          >
            <p
              :class="
                routeName === 'contract-managers'
                  ? 'active-menu-item text-primary'
                  : 'text-text'
              "
              class="flex items-center hover:text-primary item-list-custom mt-3"
            >
              <span
                class="rounded-full w-5 h-5 block mr-3 item-list-circle"
              ></span>
              <span>{{ $t("nav.contract-managers") }}</span>
            </p>
          </RouterLink>
          <RouterLink
            v-if="
              authStore.accountPermissions.allowedAny([KPN.CURRENCIES_ENABLED])
            "
            @click="close"
            :to="{ name: 'currencies' }"
          >
            <p
              :class="
                routeName === 'currencies'
                  ? 'active-menu-item text-primary'
                  : 'text-text'
              "
              class="flex items-center hover:text-primary item-list-custom mt-3"
            >
              <span
                class="rounded-full w-5 h-5 block mr-3 item-list-circle"
              ></span>
              <span>{{ $t("nav.currencies") }}</span>
            </p>
          </RouterLink>
          <RouterLink
            v-if="
              authStore.accountPermissions.allowedAny([KPN.DEPARTMENTS_ENABLED])
            "
            @click="close"
            :to="{ name: 'departments' }"
          >
            <p
              :class="
                routeName === 'departments'
                  ? 'active-menu-item text-primary'
                  : 'text-text'
              "
              class="flex items-center hover:text-primary item-list-custom mt-3"
            >
              <span
                class="rounded-full w-5 h-5 block mr-3 item-list-circle"
              ></span>
              <span>{{ $t("nav.departments") }}</span>
            </p>
          </RouterLink>
          <RouterLink
            v-if="
              authStore.accountPermissions.allowedAny([
                KPN.EXCHANGERATES_ENABLED,
              ])
            "
            @click="close"
            :to="{ name: 'exchange-rates' }"
          >
            <p
              :class="
                routeName === 'exchange-rates'
                  ? 'active-menu-item text-primary'
                  : 'text-text'
              "
              class="flex items-center hover:text-primary item-list-custom mt-3"
            >
              <span
                class="rounded-full w-5 h-5 block mr-3 item-list-circle"
              ></span>
              <span>{{ $t("nav.exchange-rates") }}</span>
            </p>
          </RouterLink>
          <RouterLink
            v-if="
              authStore.accountPermissions.allowedAny([KPN.INDOORSALES_ENABLED])
            "
            @click="close"
            :to="{ name: 'indoor-sales' }"
          >
            <p
              :class="
                routeName === 'indoor-sales'
                  ? 'active-menu-item text-primary'
                  : 'text-text'
              "
              class="flex items-center hover:text-primary item-list-custom mt-3"
            >
              <span
                class="rounded-full w-5 h-5 block mr-3 item-list-circle"
              ></span>
              <span>{{ $t("nav.indoor-sales") }}</span>
            </p>
          </RouterLink>
          <RouterLink
            v-if="
              authStore.accountPermissions.allowedAny([
                KPN.INVOICELINES_ENABLED,
              ])
            "
            @click="close"
            :to="{ name: 'invoice-lines' }"
          >
            <p
              :class="
                routeName === 'invoice-lines'
                  ? 'active-menu-item text-primary'
                  : 'text-text'
              "
              class="flex items-center hover:text-primary item-list-custom mt-3"
            >
              <span
                class="rounded-full w-5 h-5 block mr-3 item-list-circle"
              ></span>
              <span>{{ $t("nav.invoice-lines") }}</span>
            </p>
          </RouterLink>
          <RouterLink
            v-if="
              authStore.accountPermissions.allowedAny([
                KPN.KEYACCOUNTMANAGERS_ENABLED,
              ])
            "
            @click="close"
            :to="{ name: 'key-account-managers' }"
          >
            <p
              :class="
                routeName === 'key-account-managers'
                  ? 'active-menu-item text-primary'
                  : 'text-text'
              "
              class="flex items-center hover:text-primary item-list-custom mt-3"
            >
              <span
                class="rounded-full w-5 h-5 block mr-3 item-list-circle"
              ></span>
              <span>{{ $t("nav.key-account-managers") }}</span>
            </p>
          </RouterLink>
          <RouterLink
            v-if="
              authStore.accountPermissions.allowedAny([
                KPN.PAYMENTTERMS_ENABLED,
              ])
            "
            @click="close"
            :to="{ name: 'payment-terms' }"
          >
            <p
              :class="
                routeName === 'payment-terms'
                  ? 'active-menu-item text-primary'
                  : 'text-text'
              "
              class="flex items-center hover:text-primary item-list-custom mt-3"
            >
              <span
                class="rounded-full w-5 h-5 block mr-3 item-list-circle"
              ></span>
              <span>{{ $t("nav.payment-terms") }}</span>
            </p>
          </RouterLink>
          <RouterLink
            v-if="
              authStore.accountPermissions.allowedAny([
                KPN.SALESPERSONS_ENABLED,
              ])
            "
            @click="close"
            :to="{ name: 'sales-persons' }"
          >
            <p
              :class="
                routeName === 'sales-persons'
                  ? 'active-menu-item text-primary'
                  : 'text-text'
              "
              class="flex items-center hover:text-primary item-list-custom mt-3"
            >
              <span
                class="rounded-full w-5 h-5 block mr-3 item-list-circle"
              ></span>
              <span>{{ $t("nav.sales-persons") }}</span>
            </p>
          </RouterLink>
          <RouterLink
            v-if="
              authStore.accountPermissions.allowedAny([
                KPN.TOOLTIPCATEGORIES_ENABLED,
              ])
            "
            @click="close"
            :to="{ name: 'tooltip-categories' }"
          >
            <p
              :class="
                routeName === 'tooltip-categories'
                  ? 'active-menu-item text-primary'
                  : 'text-text'
              "
              class="flex items-center hover:text-primary item-list-custom mt-3"
            >
              <span
                class="rounded-full w-5 h-5 block mr-3 item-list-circle"
              ></span>
              <span>{{ $t("nav.tooltip_categories") }}</span>
            </p>
          </RouterLink>
          <RouterLink
            v-if="
              authStore.accountPermissions.allowedAny([
                KPN.WEBMAILDOMAINS_ENABLED,
              ])
            "
            @click="close"
            :to="{ name: 'webmail-domains' }"
          >
            <p
              :class="
                routeName === 'webmail-domains'
                  ? 'active-menu-item text-primary'
                  : 'text-text'
              "
              class="flex items-center hover:text-primary item-list-custom mt-3"
            >
              <span
                class="rounded-full w-5 h-5 block mr-3 item-list-circle"
              ></span>
              <span>{{ $t("nav.webmail-domains") }}</span>
            </p>
          </RouterLink>
        </div>
      </template>
      <template v-if="authStore.accountPermissions.allowedAny([KPN.ETRANSPORT_ENABLED])">
        <div class="flex items-center justify-between mt-6">
          <p class="uppercase font-semibold text-primary text-sm">
            E-Transport
          </p>
          <div @click="toggleEtransport" :class="{ 'rotate-180': isEtransportOpen }">
            <IconOpenSection />
          </div>
        </div>
        <div v-show="isEtransportOpen">
          <RouterLink
              v-if="authStore.accountPermissions.allowedAny([KPN.UITCODES_ENABLED])"
              @click="close"
              :to="{ name: 'etransport-declarations' }"
          >
            <p :class="routeName === 'etransport-declarations'
                  ? 'active-menu-item text-primary'
                  : 'text-text'"
               class="flex items-center hover:text-primary item-list-custom mt-3"
            >
              <span class="rounded-full w-5 h-5 block mr-3 item-list-circle"></span>
              <span>UIT Codes</span>
            </p>
          </RouterLink>
        </div>
      </template>
      <template v-if="authStore.accountPermissions.allowedAny([KPN.TRANSPORTSITECONFIGURATION_ENABLED])">
        <div class="flex items-center justify-between mt-6">
          <p class="uppercase font-semibold text-primary text-sm">
            {{ $t("nav.transport_site_configuration") }}
          </p>
          <div @click="toggleTransportSiteConfig" :class="{ 'rotate-180': isTransportSiteConfigOpen }">
            <IconOpenSection />
          </div>
        </div>
        <div v-show="isTransportSiteConfigOpen">
          <RouterLink
              v-if="authStore.accountPermissions.allowedAny([KPN.APISTATUSES_ENABLED])"
              @click="close"
              :to="{ name: 'activity-statuses' }"
          >
            <p :class="routeName === 'activity-statuses'
                  ? 'active-menu-item text-primary'
                  : 'text-text'"
               class="flex items-center hover:text-primary item-list-custom mt-3"
            >
              <span class="rounded-full w-5 h-5 block mr-3 item-list-circle"></span>
              <span>{{ $t("nav.activity_statuses") }}</span>
            </p>
          </RouterLink>
          <RouterLink
              v-if="authStore.accountPermissions.allowedAny([KPN.APISTATUSES_ENABLED])"
              @click="close"
              :to="{ name: 'activity-types' }"
          >
            <p :class="routeName === 'activity-types'
                  ? 'active-menu-item text-primary'
                  : 'text-text'"
               class="flex items-center hover:text-primary item-list-custom mt-3"
            >
              <span class="rounded-full w-5 h-5 block mr-3 item-list-circle"></span>
              <span>{{ $t("nav.activity_types") }}</span>
            </p>
          </RouterLink>
          <RouterLink
              v-if="authStore.accountPermissions.allowedAny([KPN.LEGALHOLIDAYS_ENABLED])"
              @click="close"
              :to="{ name: 'legal-holidays' }"
          >
            <p :class="routeName === 'legal-holidays'
                  ? 'active-menu-item text-primary'
                  : 'text-text'"
               class="flex items-center hover:text-primary item-list-custom mt-3"
            >
              <span class="rounded-full w-5 h-5 block mr-3 item-list-circle"></span>
              <span>{{ $t("nav.legal-holidays") }}</span>
            </p>
          </RouterLink>
        </div>
      </template>
      <template v-if="authStore.accountPermissions.allowedAny([KPN.WAREHOUSINGSITECONFIGURATION_ENABLED])">
        <div class="flex items-center justify-between mt-6">
          <p class="uppercase font-semibold text-primary text-sm">
            {{ $t("nav.warehousing_site_configuration") }}
          </p>
          <div @click="toggleWarehousingSiteConfig" :class="{ 'rotate-180': isWarehousingSiteConfigOpen }">
            <IconOpenSection />
          </div>
        </div>
        <div v-show="isWarehousingSiteConfigOpen">
          <RouterLink
              v-if="authStore.accountPermissions.allowedAny([KPN.SHIPPERS_ENABLED])"
              @click="close"
              :to="{ name: 'shippers' }"
          >
            <p :class="routeName === 'shippers'
                  ? 'active-menu-item text-primary'
                  : 'text-text'"
               class="flex items-center hover:text-primary item-list-custom mt-3"
            >
              <span class="rounded-full w-5 h-5 block mr-3 item-list-circle"></span>
              <span>{{ $t("nav.shippers") }}</span>
            </p>
          </RouterLink>
        </div>
      </template>
      <template v-if="authStore.accountPermissions.allowedAny([KPN.ANNOUNCEMENTS_ENABLED])">
        <div class="flex items-center justify-between mt-6">
          <p class="uppercase font-semibold text-primary text-sm">
            Announcements
          </p>
          <div @click="toggleAnnouncements" :class="{ 'rotate-180': isAnnouncementsOpen }">
            <IconOpenSection />
          </div>
        </div>
        <div v-show="isAnnouncementsOpen">
          <RouterLink
            v-if="
              authStore.accountPermissions.allowedAny([
                KPN.ALERT_ENABLED,
              ])
            "
            @click="close"
            :to="{ name: 'alerts' }"
          >
            <p
              :class="
                routeName === 'alerts'
                  ? 'active-menu-item text-primary'
                  : 'text-text'
              "
              class="flex items-center hover:text-primary item-list-custom mt-3"
            >
              <span
                class="rounded-full w-5 h-5 block mr-3 item-list-circle"
              ></span>
              <span>Alerts</span>
            </p>
          </RouterLink>
          <RouterLink
            v-if="
              authStore.accountPermissions.allowedAny([KPN.APIRELEASES_ENABLED])
            "
            @click="close"
            :to="{ name: 'api-releases' }"
          >
            <p
              :class="
                routeName === 'api-releases'
                  ? 'active-menu-item text-primary'
                  : 'text-text'
              "
              class="flex items-center hover:text-primary item-list-custom mt-3"
            >
              <span
                class="rounded-full w-5 h-5 block mr-3 item-list-circle"
              ></span>
              <span>{{ $t("nav.api-releases") }}</span>
            </p>
          </RouterLink>
          <RouterLink
            v-if="
              authStore.accountPermissions.allowedAny([
                KPN.NOTIFICATIONS_ENABLED,
              ])
            "
            @click="close"
            :to="{ name: 'notifications' }"
          >
            <p
              :class="
                routeName === 'notifications'
                  ? 'active-menu-item text-primary'
                  : 'text-text'
              "
              class="flex items-center hover:text-primary item-list-custom mt-3"
            >
              <span
                class="rounded-full w-5 h-5 block mr-3 item-list-circle"
              ></span>
              <span>{{ $t("nav.notifications") }}</span>
            </p>
          </RouterLink>
          <RouterLink
            v-if="
              authStore.accountPermissions.allowedAny([
                KPN.RELEASES_ENABLED,
              ])
            "
            @click="close"
            :to="{ name: 'releases' }"
          >
            <p
              :class="
                routeName === 'releases'
                  ? 'active-menu-item text-primary'
                  : 'text-text'
              "
              class="flex items-center hover:text-primary item-list-custom mt-3"
            >
              <span
                class="rounded-full w-5 h-5 block mr-3 item-list-circle"
              ></span>
              <span>{{ $t("nav.releases") }}</span>
            </p>
          </RouterLink>
          <RouterLink
            v-if="
              authStore.accountPermissions.allowedAny([
                KPN.SITENOTIFICATIONS_ENABLED,
              ])
            "
            @click="close"
            :to="{ name: 'site-notifications' }"
          >
            <p
              :class="
                routeName === 'site-notifications'
                  ? 'active-menu-item text-primary'
                  : 'text-text'
              "
              class="flex items-center hover:text-primary item-list-custom mt-3"
            >
              <span
                class="rounded-full w-5 h-5 block mr-3 item-list-circle"
              ></span>
              <span>{{ $t("nav.site-notifications") }}</span>
            </p>
          </RouterLink>
        </div>
      </template>
      <template v-if="authStore.accountPermissions.allowedAny([KPN.ACCESSTOKENS_ENABLED])">
        <div class="flex items-center justify-between mt-6">
          <p class="uppercase font-semibold text-primary text-sm">
            {{ $t("nav.access-tokens") }}
          </p>
          <div @click="toggleAccessTokens" :class="{ 'rotate-180': isAccessTokensOpen }">
            <IconOpenSection />
          </div>
        </div>
        <div v-show="isAccessTokensOpen">
          <RouterLink v-if="authStore.accountPermissions.allowedAny([KPN.CLIENTMCPTOKENS_ENABLED])"
                      @click="close"
                      :to="{ name: 'client-mcp-tokens' }">
            <p :class="
                routeName === 'client-mcp-tokens'
                  ? 'active-menu-item text-primary'
                  : 'text-text'"
               class="flex items-center hover:text-primary item-list-custom mt-3"
            >
              <span class="rounded-full w-5 h-5 block mr-3 item-list-circle"></span>
              <span>Client MCP Tokens</span>
            </p>
          </RouterLink>
          <RouterLink v-if="authStore.accountPermissions.allowedAny([KPN.KRAKENDENDPOINTS_ENABLED])"
            @click="close"
            :to="{ name: 'krakend-endpoints' }">
            <p :class="
                routeName === 'krakend-endpoints'
                  ? 'active-menu-item text-primary'
                  : 'text-text'"
              class="flex items-center hover:text-primary item-list-custom mt-3"
            >
              <span class="rounded-full w-5 h-5 block mr-3 item-list-circle"></span>
              <span>{{ $t("nav.krakend-endpoints") }}</span>
            </p>
          </RouterLink>
          <RouterLink v-if="authStore.accountPermissions.allowedAny([KPN.KRAKENDTOKENS_ENABLED])"
            @click="close"
            :to="{ name: 'krakend-tokens' }">
            <p :class="
                routeName === 'krakend-tokens'
                  ? 'active-menu-item text-primary'
                  : 'text-text'"
              class="flex items-center hover:text-primary item-list-custom mt-3"
            >
              <span class="rounded-full w-5 h-5 block mr-3 item-list-circle"></span>
              <span>{{ $t("nav.krakend-tokens") }}</span>
            </p>
          </RouterLink>
          <RouterLink v-if="authStore.accountPermissions.allowedAny([KPN.MCPSESSIONS_ENABLED])"
                      @click="close"
                      :to="{ name: 'mcp-tokens' }">
            <p :class="
                routeName === 'mcp-tokens'
                  ? 'active-menu-item text-primary'
                  : 'text-text'"
               class="flex items-center hover:text-primary item-list-custom mt-3"
            >
              <span class="rounded-full w-5 h-5 block mr-3 item-list-circle"></span>
              <span>MCP Tokens</span>
            </p>
          </RouterLink>
          <RouterLink v-if="authStore.accountPermissions.allowedAny([KPN.ONECLICKTOKENS_ENABLED])"
            @click="close"
            :to="{ name: 'oneclick-tokens' }">
            <p :class="
                routeName === 'oneclick-tokens'
                  ? 'active-menu-item text-primary'
                  : 'text-text'"
              class="flex items-center hover:text-primary item-list-custom mt-3"
            >
              <span class="rounded-full w-5 h-5 block mr-3 item-list-circle"></span>
              <span>{{ $t("nav.oneclick-tokens") }}</span>
            </p>
          </RouterLink>
          <RouterLink v-if="authStore.accountPermissions.allowedAny([KPN.ACCESSTOKENS_ENABLED])"
                      @click="close"
                      :to="{ name: 'applications' }">
            <p :class="
                routeName === 'applications'
                  ? 'active-menu-item text-primary'
                  : 'text-text'"
               class="flex items-center hover:text-primary item-list-custom mt-3"
            >
              <span class="rounded-full w-5 h-5 block mr-3 item-list-circle"></span>
              <span>Registered Applications</span>
            </p>
          </RouterLink>
        </div>
      </template>
      <template v-if="authStore.accountPermissions.allowedAny([KPN.CLIENTDOCUMENTATION_ENABLED])">
        <div class="flex items-center justify-between mt-6">
          <p class="uppercase font-semibold text-primary text-sm">
            {{ $t("nav.api-docs") }}
          </p>
          <div @click="toggleClientDocumentation" :class="{ 'rotate-180': isClientDocumentationOpen }">
            <IconOpenSection />
          </div>
        </div>
        <div v-show="isClientDocumentationOpen">
          <RouterLink
            v-if="
              authStore.accountPermissions.allowedAny([
                KPN.APIRESOURCES_ENABLED,
              ])
            "
            @click="close"
            :to="{ name: 'api-resources-listing' }"
          >
            <p
              :class="
                routeName === 'api-resources-listing'
                  ? 'active-menu-item text-primary'
                  : 'text-text'
              "
              class="flex items-center hover:text-primary item-list-custom mt-3"
            >
              <span
                class="rounded-full w-5 h-5 block mr-3 item-list-circle"
              ></span>
              <span>{{ $t("nav.api-resources") }}</span>
            </p>
          </RouterLink>
          <RouterLink
            v-if="
              authStore.accountPermissions.allowedAny([
                KPN.APIRESOURCEFIELDS_ENABLED,
              ])
            "
            @click="close"
            :to="{ name: 'api-resources-fields-listing' }"
          >
            <p
              :class="
                routeName === 'api-resources-fields-listing'
                  ? 'active-menu-item text-primary'
                  : 'text-text'
              "
              class="flex items-center hover:text-primary item-list-custom mt-3"
            >
              <span
                class="rounded-full w-5 h-5 block mr-3 item-list-circle"
              ></span>
              <span>{{ $t("nav.oneclick-fields") }}</span>
            </p>
          </RouterLink>
          <RouterLink
            v-if="
              authStore.accountPermissions.allowedAny([
                KPN.APIROUTEGROUPS_ENABLED,
              ])
            "
            @click="close"
            :to="{ name: 'api-route-groups' }"
          >
            <p
              :class="
                routeName === 'api-route-groups'
                  ? 'active-menu-item text-primary'
                  : 'text-text'
              "
              class="flex items-center hover:text-primary item-list-custom mt-3"
            >
              <span
                class="rounded-full w-5 h-5 block mr-3 item-list-circle"
              ></span>
              <span>{{ $t("nav.api-route-groups") }}</span>
            </p>
          </RouterLink>
        </div>
      </template>
      <template v-if="authStore.accountPermissions.allowedAny([KPN.APPLICATIONSAPI_ENABLED])">
        <div class="flex items-center justify-between mt-6">
          <p class="uppercase font-semibold text-primary text-sm">
            Applications API
          </p>
          <div @click="toggleApplicationsApi" :class="{ 'rotate-180': isApplicationsApiOpen }">
            <IconOpenSection />
          </div>
        </div>
        <div v-show="isApplicationsApiOpen">
          <RouterLink
            v-if="
              authStore.accountPermissions.allowedAny([
                KPN.APPLICATIONSAPIRESOURCE_ENABLED,
              ])
            "
            @click="close"
            :to="{ name: 'application-api-resources-listing' }"
          >
            <p
              :class="
                routeName === 'application-api-resources-listing'
                  ? 'active-menu-item text-primary'
                  : 'text-text'
              "
              class="flex items-center hover:text-primary item-list-custom mt-3"
            >
              <span
                class="rounded-full w-5 h-5 block mr-3 item-list-circle"
              ></span>
              <span>API Resources</span>
            </p>
          </RouterLink>
          <RouterLink
            v-if="
              authStore.accountPermissions.allowedAny([
                KPN.APPLICATIONSAPIRESOURCEFIELDS_ENABLED,
              ])
            "
            @click="close"
            :to="{ name: 'application-api-resource-fields-listing' }"
          >
            <p
              :class="
                routeName === 'application-api-resource-fields-listing'
                  ? 'active-menu-item text-primary'
                  : 'text-text'
              "
              class="flex items-center hover:text-primary item-list-custom mt-3"
            >
              <span
                class="rounded-full w-5 h-5 block mr-3 item-list-circle"
              ></span>
              <span>API Resource Fields</span>
            </p>
          </RouterLink>
          <RouterLink
            v-if="
              authStore.accountPermissions.allowedAny([
                KPN.APPLICATIONSAPIROUTEGROUPS_ENABLED,
              ])
            "
            @click="close"
            :to="{ name: 'application-api-route-groups' }"
          >
            <p
              :class="
                routeName === 'application-api-route-groups'
                  ? 'active-menu-item text-primary'
                  : 'text-text'
              "
              class="flex items-center hover:text-primary item-list-custom mt-3"
            >
              <span
                class="rounded-full w-5 h-5 block mr-3 item-list-circle"
              ></span>
              <span>API Route Groups</span>
            </p>
          </RouterLink>
          <RouterLink
            v-if="
              authStore.accountPermissions.allowedAll([
                KPN.APPLICATIONSAPI_ENABLED,
                KPN.APPLICATIONSAPIROUTES_FORM_APPLICATIONAPIROUTE_VIEW,
              ])
            "
            @click="close"
            :to="{ name: 'application-api-documentation' }"
          >
            <p
              :class="
                routeName === 'application-api-documentation'
                  ? 'active-menu-item text-primary'
                  : 'text-text'
              "
              class="flex items-center hover:text-primary item-list-custom mt-3"
            >
              <span
                class="rounded-full w-5 h-5 block mr-3 item-list-circle"
              ></span>
              <span>Documentation</span>
            </p>
          </RouterLink>
        </div>
      </template>
      <template v-if="authStore.accountPermissions.allowedAny([KPN.ORDERENTRYSETTINGSMODULE_ENABLED])">
        <div class="flex items-center justify-between mt-6">
          <p class="uppercase font-semibold text-primary text-sm">
            {{ $t("nav.order-entry") }}
          </p>
          <div
            @click="toggleOrderEntry"
            :class="{ 'rotate-180': isOrderEntryOpen }"
          >
            <IconOpenSection />
          </div>
        </div>
        <div v-show="isOrderEntryOpen">
          <RouterLink
            v-if="
              authStore.accountPermissions.allowedAny([
                KPN.ORDERENTRYGENERALSETTINGS_ENABLED,
              ])
            "
            @click="close"
            :to="{ name: 'general-settings' }"
          >
            <p
              :class="
                routeName === 'general-settings'
                  ? 'active-menu-item text-primary'
                  : 'text-text'
              "
              class="flex items-center hover:text-primary item-list-custom mt-3"
            >
              <span
                class="rounded-full w-5 h-5 block mr-3 item-list-circle"
              ></span>
              <span>{{ $t("nav.order-entry-general") }}</span>
            </p>
          </RouterLink>
          <RouterLink
            v-if="
              authStore.accountPermissions.allowedAny([
                KPN.ORDERENTRYINCOTERMS_ENABLED,
              ])
            "
            @click="close"
            :to="{ name: 'incoterms' }"
          >
            <p
              :class="
                routeName === 'incoterms'
                  ? 'active-menu-item text-primary'
                  : 'text-text'
              "
              class="flex items-center hover:text-primary item-list-custom mt-3"
            >
              <span
                class="rounded-full w-5 h-5 block mr-3 item-list-circle"
              ></span>
              <span>{{ $t("nav.order-entry-incoterms") }}</span>
            </p>
          </RouterLink>
          <RouterLink
            v-if="
              authStore.accountPermissions.allowedAny([
                KPN.ORDERENTRYPACKAGES_ENABLED,
              ])
            "
            @click="close"
            :to="{ name: 'packages' }"
          >
            <p
              :class="
                routeName === 'packages'
                  ? 'active-menu-item text-primary'
                  : 'text-text'
              "
              class="flex items-center hover:text-primary item-list-custom mt-3"
            >
              <span
                class="rounded-full w-5 h-5 block mr-3 item-list-circle"
              ></span>
              <span>{{ $t("nav.order-entry-packages") }}</span>
            </p>
          </RouterLink>
          <RouterLink
            v-if="
              authStore.accountPermissions.allowedAny([
                KPN.ORDERENTRYFEATURES_ENABLED,
              ])
            "
            @click="close"
            :to="{ name: 'features' }"
          >
            <p
              :class="
                routeName === 'features'
                  ? 'active-menu-item text-primary'
                  : 'text-text'
              "
              class="flex items-center hover:text-primary item-list-custom mt-3"
            >
              <span
                class="rounded-full w-5 h-5 block mr-3 item-list-circle"
              ></span>
              <span>{{ $t("nav.order-entry-features") }}</span>
            </p>
          </RouterLink>
        </div>
      </template>
      <template v-if="authStore.accountPermissions.allowedAny([KPN.AIAGENTS_ENABLED])">
        <div class="flex items-center justify-between mt-6">
          <p class="uppercase font-semibold text-primary text-sm">
            {{ $t("nav.ai") }}
          </p>
          <div @click="toggleAi" :class="{ 'rotate-180': isAiOpen }">
            <IconOpenSection />
          </div>
        </div>
        <div v-show="isAiOpen">
          <RouterLink
            v-if="
              authStore.accountPermissions.allowedAny([
                KPN.AIAGENTSCONFIGURATION_ENABLED,
              ])
            "
            @click="close"
            :to="{ name: 'ai-agents' }"
          >
            <div
              :class="
                routeName === 'ai-agents'
                  ? 'active-menu-item text-primary bg-gray-50'
                  : '  text-secondary hover:bg-gray-50'
              "
              class="flex items-center hover:text-primary item-list-custom p-1 rounded-lg stroke-black hover:stroke-primary space-x-2 transition-all ease-in-out duration-500"
            >
              <div
                :class="routeName === 'ai-agents' ? 'fill-primary' : ''"
                class="transition-colors ease-in-out duration-300 shadow-softxl mr-2 flex h-10 w-10 items-center justify-center rounded-lg bg-center text-center p-2"
              >
                <IconAiChat />
              </div>
              <span>{{ $t("nav.ai-agents") }}</span>
            </div>
          </RouterLink>
          <RouterLink
            v-if="
              authStore.accountPermissions.allowedAny([KPN.AIDASHBOARD_ENABLED])
            "
            @click="close"
            :to="{ name: 'ai-dashboard' }"
          >
            <div
              :class="
                routeName === 'ai-dashboard'
                  ? 'active-menu-item text-primary bg-gray-50'
                  : '  text-secondary hover:bg-gray-50'
              "
              class="flex items-center hover:text-primary item-list-custom p-1 rounded-lg stroke-black hover:stroke-primary space-x-2 transition-all ease-in-out duration-500"
            >
              <div
                :class="routeName === 'ai-dashboard' ? 'fill-primary' : ''"
                class="transition-colors ease-in-out duration-300 shadow-softxl mr-2 flex h-10 w-10 items-center justify-center rounded-lg bg-center text-center p-2"
              >
                <IconAi />
              </div>
              <span>{{ $t("nav.ai-dashboard") }}</span>
            </div>
          </RouterLink>
          <RouterLink
            v-if="
              authStore.accountPermissions.allowedAny([KPN.CLEODOCUMENTS_ENABLED])
            "
            @click="close"
            :to="{ name: 'cleo-documents' }"
          >
            <div
              :class="
                routeName === 'cleo-documents'
                  ? 'active-menu-item text-primary bg-gray-50'
                  : '  text-secondary hover:bg-gray-50'
              "
              class="flex items-center hover:text-primary item-list-custom p-1 rounded-lg stroke-black hover:stroke-primary space-x-2 transition-all ease-in-out duration-500"
            >
              <div
                :class="routeName === 'cleo-documents' ? 'fill-primary' : ''"
                class="transition-colors ease-in-out duration-300 shadow-softxl mr-2 flex h-10 w-10 items-center justify-center rounded-lg bg-center text-center p-2"
              >
                <IconCleoDocuments />
              </div>
              <span>Cleo Documents</span>
            </div>
          </RouterLink>
          <RouterLink
            v-if="
              authStore.accountPermissions.allowedAny([KPN.CLEO_ENABLED])
            "
            @click="close"
            :to="{ name: 'cleo-history' }"
          >
            <div
              :class="
                routeName === 'cleo-history'
                  ? 'active-menu-item text-primary bg-gray-50'
                  : '  text-secondary hover:bg-gray-50'
              "
              class="flex items-center hover:text-primary item-list-custom p-1 rounded-lg stroke-black hover:stroke-primary space-x-2 transition-all ease-in-out duration-500"
            >
              <div
                :class="routeName === 'cleo-history' ? 'fill-primary' : ''"
                class="transition-colors ease-in-out duration-300 shadow-softxl mr-2 flex h-10 w-10 items-center justify-center rounded-lg bg-center text-center p-2"
              >
                <IconCleoHistory />
              </div>
              <span>{{ $t("nav.cleo-history") }}</span>
            </div>
          </RouterLink>
          <RouterLink
            v-if="
              authStore.accountPermissions.allowedAny([KPN.CLEOINSIGHTS_ENABLED])
            "
            @click="close"
            :to="{ name: 'cleo-insights' }"
          >
            <div
              :class="
                routeName === 'cleo-insights'
                  ? 'active-menu-item text-primary bg-gray-50'
                  : '  text-secondary hover:bg-gray-50'
              "
              class="flex items-center hover:text-primary item-list-custom p-1 rounded-lg stroke-black hover:stroke-primary space-x-2 transition-all ease-in-out duration-500"
            >
              <div
                :class="routeName === 'cleo-insights' ? 'fill-primary' : ''"
                class="transition-colors ease-in-out duration-300 shadow-softxl mr-2 flex h-10 w-10 items-center justify-center rounded-lg bg-center text-center p-2"
              >
                <IconCleoInsights />
              </div>
              <span>Cleo Insights</span>
            </div>
          </RouterLink>
          <RouterLink
            v-if="
              authStore.accountPermissions.allowedAny([KPN.CLEOLIMITS_ENABLED])
            "
            @click="close"
            :to="{ name: 'cleo-limits' }"
          >
            <div
              :class="
                routeName === 'cleo-limits'
                  ? 'active-menu-item text-primary bg-gray-50'
                  : '  text-secondary hover:bg-gray-50'
              "
              class="flex items-center hover:text-primary item-list-custom p-1 rounded-lg stroke-black hover:stroke-primary space-x-2 transition-all ease-in-out duration-500"
            >
              <div
                :class="routeName === 'cleo-limits' ? 'fill-primary' : ''"
                class="transition-colors ease-in-out duration-300 shadow-softxl mr-2 flex h-10 w-10 items-center justify-center rounded-lg bg-center text-center p-2"
              >
                <IconCleoLimits />
              </div>
              <span>Cleo Limits</span>
            </div>
          </RouterLink>
          <RouterLink
            v-if="
              authStore.accountPermissions.allowedAny([KPN.CLIENTCLEO_ENABLED])
            "
            @click="close"
            :to="{ name: 'client-cleo-history' }"
          >
            <div
              :class="
                routeName === 'client-cleo-history'
                  ? 'active-menu-item text-primary bg-gray-50'
                  : '  text-secondary hover:bg-gray-50'
              "
              class="flex items-center hover:text-primary item-list-custom p-1 rounded-lg stroke-black hover:stroke-primary space-x-2 transition-all ease-in-out duration-500"
            >
              <div
                :class="routeName === 'client-cleo-history' ? 'fill-primary' : ''"
                class="transition-colors ease-in-out duration-300 shadow-softxl mr-2 flex h-10 w-10 items-center justify-center rounded-lg bg-center text-center p-2"
              >
                <IconClientCleoHistory />
              </div>
              <span>Client Cleo History</span>
            </div>
          </RouterLink>
        </div>
      </template>
      <template v-if="authStore.accountPermissions.allowedAny([KPN.KLGUSERSANDPERMISSIONS_ENABLED])">
        <div class="flex items-center justify-between mt-6">
          <p class="uppercase font-semibold text-primary text-sm">
            {{ $t("nav.klg_users_and_permissions") }}
          </p>
          <div
            @click="toggleKlgUsers"
            :class="{ 'rotate-180': isKlgUsersOpen }"
          >
            <IconOpenSection />
          </div>
        </div>
        <div v-show="isKlgUsersOpen">
          <RouterLink
            v-if="authStore.accountPermissions.allowedAny([KPN.USERS_ENABLED])"
            @click="close"
            :to="{ name: 'klg-users-listing' }"
          >
            <div
              :class="
                routeName === 'klg-users-listing'
                  ? 'active-menu-item text-primary bg-gray-50'
                  : '  text-secondary hover:bg-gray-50'
              "
              class="flex items-center hover:text-primary item-list-custom p-1 mt-2 rounded-lg hover:fill-primary space-x-2 transition-all ease-in-out duration-500"
            >
              <div
                :class="routeName === 'klg-users-listing' ? 'fill-primary' : ''"
                class="transition-colors ease-in-out duration-300 shadow-softxl mr-2 flex h-9 w-9 items-center justify-center rounded-lg bg-center text-center p-2"
              >
                <IconUsers />
              </div>
              <span>{{ $t("nav.klg-users") }}</span>
            </div>
          </RouterLink>
          <RouterLink
            v-if="
              authStore.accountPermissions.allowedAny([
                KPN.ROLESANDPERMISSIONS_ENABLED,
              ])
            "
            @click="close"
            :to="{ name: 'klg-roles-permissions' }"
          >
            <div
              :class="
                routeName === 'klg-roles-permissions'
                  ? 'active-menu-item text-primary bg-gray-50'
                  : '  text-secondary hover:bg-gray-50'
              "
              class="flex items-center hover:text-primary item-list-custom p-1 space-x-2 hover:fill-primary rounded-lg transition-all ease-in-out duration-500"
            >
              <div
                :class="
                  routeName === 'klg-roles-permissions' ? 'fill-primary' : ''
                "
                class="transition-colors ease-in-out duration-300 shadow-softxl mr-2 flex h-9 w-9 items-center justify-center rounded-lg bg-center text-center p-2"
              >
                <IconRoles />
              </div>
              <span>{{ $t("nav.klg-users-roles-permissions") }}</span>
            </div>
          </RouterLink>
          <RouterLink
            v-if="
              authStore.accountPermissions.allowedAny([KPN.LOGINASROLE_ENABLED])
            "
            @click="close"
            :to="{ name: 'klg-roles-permissions-login-as' }"
          >
            <div
              :class="
                routeName === 'klg-roles-permissions-login-as'
                  ? 'active-menu-item text-primary bg-gray-50'
                  : '  text-secondary hover:bg-gray-50'
              "
              class="flex items-center hover:text-primary item-list-custom p-1 space-x-2 hover:fill-primary rounded-lg transition-all ease-in-out duration-500"
            >
              <div
                :class="
                  routeName === 'klg-roles-permissions-login-as'
                    ? 'fill-primary'
                    : ''
                "
                class="transition-colors ease-in-out duration-300 shadow-softxl mr-2 flex h-9 w-9 items-center justify-center rounded-lg bg-center text-center p-2"
              >
                <IconRoles />
              </div>
              <span>{{ $t("nav.klg-users-roles-permissions-login-as") }}</span>
            </div>
          </RouterLink>
        </div>
      </template>
      <template v-if="authStore.accountPermissions.allowedAny([KPN.COMPANIESANDPERMISSIONS_ENABLED])">
        <div class="flex items-center justify-between mt-6">
          <p class="uppercase font-semibold text-primary text-sm">
            {{ $t("nav.clients_and_permissions") }}
          </p>
          <div @click="toggleClients" :class="{ 'rotate-180': isClientsOpen }">
            <IconOpenSection />
          </div>
        </div>
        <div v-show="isClientsOpen">
          <RouterLink
            v-if="
              authStore.accountPermissions.allowedAny([KPN.COMPANIES_ENABLED])
            "
            @click="close"
            :to="{ name: 'clients-listing' }"
          >
            <div
              :class="
                routeName === 'clients-listing'
                  ? 'active-menu-item text-primary bg-gray-50'
                  : '  text-secondary hover:bg-gray-50'
              "
              class="flex items-center hover:text-primary item-list-custom p-1 mt-2 rounded-lg hover:fill-primary space-x-2 transition-all ease-in-out duration-500"
            >
              <div
                :class="routeName === 'clients-listing' ? 'fill-primary' : ''"
                class="transition-colors ease-in-out duration-300 shadow-softxl mr-2 flex h-9 w-9 items-center justify-center rounded-lg bg-center text-center p-2"
              >
                <IconCompanies />
              </div>
              <span>{{ $t("nav.clients") }}</span>
            </div>
          </RouterLink>
          <RouterLink
            v-if="
              authStore.accountPermissions.allowedAny([
                KPN.ALLCOMPANIESSHORTOVERVIEW_ENABLED,
              ])
            "
            @click="close"
            :to="{ name: 'all-companies' }"
          >
            <div
              :class="
                routeName === 'company-users'
                  ? 'active-menu-item text-primary bg-gray-50'
                  : '  text-secondary hover:bg-gray-50'
              "
              class="flex items-center hover:text-primary item-list-custom p-1 rounded-lg hover:fill-primary space-x-2 transition-all ease-in-out duration-500"
            >
              <div
                :class="routeName === 'company-users' ? 'fill-primary' : ''"
                class="transition-colors ease-in-out duration-300 shadow-softxl mr-2 flex h-9 w-9 items-center justify-center rounded-lg bg-center text-center p-2"
              >
                <IconCompanies />
              </div>
              <span>{{ $t("nav.companies_for_all") }}</span>
            </div>
          </RouterLink>
          <RouterLink
            v-if="
              authStore.accountPermissions.allowedAny([
                KPN.COMPANYUSERS_ENABLED,
              ])
            "
            @click="close"
            :to="{ name: 'company-users' }"
          >
            <div
              :class="
                routeName === 'company-users'
                  ? 'active-menu-item text-primary bg-gray-50'
                  : '  text-secondary hover:bg-gray-50'
              "
              class="flex items-center hover:text-primary item-list-custom p-1 rounded-lg hover:fill-primary space-x-2 transition-all ease-in-out duration-500"
            >
              <div
                :class="routeName === 'company-users' ? 'fill-primary' : ''"
                class="transition-colors ease-in-out duration-300 shadow-softxl mr-2 flex h-9 w-9 items-center justify-center rounded-lg bg-center text-center p-2"
              >
                <IconUsers />
              </div>
              <span>{{ $t("nav.company_users") }}</span>
            </div>
          </RouterLink>
          <RouterLink
            v-if="
              authStore.accountPermissions.allowedAny([KPN.CONTACTS_ENABLED])
            "
            @click="close"
            :to="{ name: 'contacts' }"
          >
            <div
              :class="
                routeName === 'contacts'
                  ? 'active-menu-item text-primary bg-gray-50'
                  : '  text-secondary hover:bg-gray-50'
              "
              class="flex items-center hover:text-primary item-list-custom p-1 rounded-lg hover:fill-primary space-x-2 transition-all ease-in-out duration-500"
            >
              <div
                :class="routeName === 'contacts' ? 'fill-primary' : ''"
                class="transition-colors ease-in-out duration-300 shadow-softxl mr-2 flex h-9 w-9 items-center justify-center rounded-lg bg-center text-center p-2"
              >
                <IconContacts />
              </div>
              <span>{{ $t("nav.contacts") }}</span>
            </div>
          </RouterLink>
          <RouterLink
            v-if="
              authStore.accountPermissions.allowedAny([
                KPN.ROLESANDPERMISSION_ENABLED,
              ])
            "
            @click="close"
            :to="{ name: 'client-roles-permissions' }"
          >
            <div
              :class="
                routeName === 'client-roles-permissions'
                  ? 'active-menu-item text-primary bg-gray-50'
                  : '  text-secondary hover:bg-gray-50'
              "
              class="flex items-center hover:text-primary item-list-custom p-1 space-x-2 hover:fill-primary rounded-lg transition-all ease-in-out duration-500"
            >
              <div
                :class="
                  routeName === 'client-roles-permissions' ? 'fill-primary' : ''
                "
                class="transition-all ease-in-out duration-500 shadow-softxl mr-2 flex h-9 w-9 items-center justify-center rounded-lg bg-center text-center p-2"
              >
                <IconRoles />
              </div>
              <span>{{ $t("nav.clients-roles-permissions") }}</span>
            </div>
          </RouterLink>
        </div>
      </template>
      <template v-if="authStore.accountPermissions.allowedAny([KPN.INVOICES_ENABLED])">
        <div class="flex items-center justify-between mt-6">
          <p class="uppercase font-semibold text-primary text-sm">
            {{ $t("nav.erp") }}
          </p>
          <div @click="toggleErp" :class="{ 'rotate-180': isErpOpen }">
            <IconOpenSection />
          </div>
        </div>
        <div v-show="isErpOpen">
          <RouterLink
            v-if="
              authStore.accountPermissions.allowedAny([KPN.ISSUEDTOKLG_ENABLED])
            "
            :to="{ name: 'vendors' }"
            @click="close"
            class=""
          >
            <div
              :class="
                routeName === 'vendors'
                  ? 'active-menu-item text-primary bg-gray-50'
                  : '  text-secondary hover:bg-gray-50'
              "
              class="flex items-center hover:text-primary item-list-custom p-1 mt-2 rounded-lg stroke-black hover:stroke-primary fill-black space-x-2 transition-all ease-in-out duration-500"
            >
              <div
                :class="routeName === 'vendors' ? 'fill-primary' : ''"
                class="transition-colors ease-in-out duration-300 shadow-softxl mr-2 flex h-10 w-10 items-center justify-center rounded-lg bg-center text-center p-2"
              >
                <IconIssuedToKlg />
              </div>
              <span>{{ $t("nav.issued-to-klg") }}</span>
            </div>
          </RouterLink>
          <RouterLink
            v-if="
              authStore.accountPermissions.allowedAny([KPN.ISSUEDBYKLG_ENABLED])
            "
            :to="{ name: 'customers' }"
            @click="close"
            class=""
          >
            <div
              :class="
                routeName === 'customers'
                  ? 'active-menu-item text-primary bg-gray-50'
                  : '  text-secondary hover:bg-gray-50'
              "
              class="flex items-center hover:text-primary item-list-custom p-1 rounded-lg stroke-black hover:stroke-primary space-x-2 transition-all ease-in-out duration-500"
            >
              <div
                :class="routeName === 'customers' ? 'fill-primary' : ''"
                class="transition-colors ease-in-out duration-300 shadow-softxl mr-2 flex h-10 w-10 items-center justify-center rounded-lg bg-center text-center p-2"
              >
                <IconIssuedByKlg />
              </div>
              <span>{{ $t("nav.issued-by-klg") }}</span>
            </div>
          </RouterLink>
        </div>
      </template>
      <template v-if="authStore.accountPermissions.allowedAny([KPN.BUSINESSLINESORDERS_ENABLED])">
        <div class="flex items-center justify-between mt-3">
          <p class="uppercase font-semibold text-primary text-sm">
            {{ $t("nav.business_lines") }}
          </p>
          <div
            @click="toggleBusinessLines"
            :class="{ 'rotate-180': isBusinessLinesOpen }"
          >
            <IconOpenSection />
          </div>
        </div>
        <div v-show="isBusinessLinesOpen">
          <RouterLink
            v-if="
              authStore.accountPermissions.allowedAny([
                KPN.WAREHOUSINGRECEPTIONRETURN_ENABLED,
              ])
            "
            :to="{ name: 'vbs-inbounds' }"
            @click="close"
            class=""
          >
            <div
              :class="
                routeName === 'vbs-inbounds'
                  ? 'active-menu-item text-primary bg-gray-50'
                  : '  text-secondary hover:bg-gray-50'
              "
              class="flex items-center hover:text-primary item-list-custom p-1 mt-2 rounded-lg hover:fill-primary space-x-2 transition-all ease-in-out duration-500"
            >
              <div
                :class="routeName === 'vbs-inbounds' ? 'fill-primary' : ''"
                class="transition-colors ease-in-out duration-300 shadow-softxl mr-2 flex h-10 w-10 items-center justify-center rounded-lg bg-center text-center p-2"
              >
                <IconWarehousingReception />
              </div>
              <span>{{ $t("nav.warehousing-reception-return") }}</span>
            </div>
          </RouterLink>
          <RouterLink
            v-if="
              authStore.accountPermissions.allowedAny([
                KPN.WAREHOUSINGORDERS_ENABLED,
              ])
            "
            :to="{ name: 'vbs-outbounds' }"
            @click="close"
            class=""
          >
            <div
              :class="
                routeName === 'vbs-outbounds'
                  ? 'active-menu-item text-primary bg-gray-50'
                  : '  text-secondary hover:bg-gray-50'
              "
              class="flex items-center hover:text-primary item-list-custom p-1 rounded-lg hover:fill-primary space-x-2 transition-all ease-in-out duration-500"
            >
              <div
                :class="routeName === 'vbs-outbounds' ? 'fill-primary' : ''"
                class="transition-colors ease-in-out duration-300 shadow-softxl mr-2 flex h-10 w-10 items-center justify-center rounded-lg bg-center text-center p-2"
              >
                <IconWarehousingOrder />
              </div>
              <span>{{ $t("nav.warehousing-orders") }}</span>
            </div>
          </RouterLink>
          <RouterLink
            v-if="
              authStore.accountPermissions.allowedAny([
                KPN.WAREHOUSINGSIMPLIFYRECEPTIONRETURN_ENABLED,
              ])
            "
            :to="{ name: 'inbounds' }"
            @click="close"
            class=""
          >
            <div
              :class="
                routeName === 'inbounds'
                  ? 'active-menu-item text-primary bg-gray-50'
                  : '  text-secondary hover:bg-gray-50'
              "
              class="flex items-center hover:text-primary item-list-custom p-1 rounded-lg hover:fill-primary space-x-2 transition-all ease-in-out duration-500"
            >
              <div
                :class="routeName === 'inbounds' ? 'fill-primary' : ''"
                class="transition-colors ease-in-out duration-300 shadow-softxl mr-2 ml-1 flex h-10 w-10 items-center justify-center rounded-lg bg-center text-center p-2"
              >
                <IconWarehousingSimplifyReception />
              </div>
              <span>{{ $t("nav.warehousing-simplify-reception-return") }}</span>
            </div>
          </RouterLink>
          <RouterLink
            v-if="
              authStore.accountPermissions.allowedAny([
                KPN.WAREHOUSINGSIMPLIFYORDER_ENABLED,
              ])
            "
            :to="{ name: 'outbounds' }"
            @click="close"
            class=""
          >
            <div
              :class="
                routeName === 'outbounds'
                  ? 'active-menu-item text-primary bg-gray-50'
                  : '  text-secondary hover:bg-gray-50'
              "
              class="flex items-center hover:text-primary item-list-custom p-1 rounded-lg hover:fill-primary space-x-2 transition-all ease-in-out duration-500"
            >
              <div
                :class="routeName === 'outbounds' ? 'fill-primary' : ''"
                class="transition-colors ease-in-out duration-300 shadow-softxl mr-2 flex h-10 w-10 items-center justify-center rounded-lg bg-center text-center p-2"
              >
                <IconWarehousingSimplifyOrder />
              </div>
              <span>{{ $t("nav.outbounds") }}</span>
            </div>
          </RouterLink>
          <RouterLink
            v-if="
              authStore.accountPermissions.allowedAny([
                KPN.INTERNATIONALROAD_ENABLED,
              ])
            "
            :to="{ name: 'international-shipments' }"
            @click="close"
            class=""
          >
            <div
              :class="
                routeName === 'international-shipments'
                  ? 'active-menu-item text-primary bg-gray-50'
                  : '  text-secondary hover:bg-gray-50'
              "
              class="flex items-center hover:text-primary item-list-custom p-1 rounded-lg hover:fill-primary space-x-2 transition-all ease-in-out duration-500"
            >
              <div
                :class="
                  routeName === 'international-shipments' ? 'fill-primary' : ''
                "
                class="transition-colors ease-in-out duration-300 shadow-softxl mr-2 flex h-10 w-10 items-center justify-center rounded-lg bg-center text-center p-2"
              >
                <IconInternationalRoad />
              </div>
              <span>{{ $t("nav.international-road") }}</span>
            </div>
          </RouterLink>
          <RouterLink
            v-if="
              authStore.accountPermissions.allowedAny([
                KPN.DOMESTICROAD_ENABLED,
              ])
            "
            :to="{ name: 'domestic-shipments' }"
            @click="close"
            class=""
          >
            <div
              :class="
                routeName === 'domestic-shipments'
                  ? 'active-menu-item text-primary bg-gray-50'
                  : '  text-secondary hover:bg-gray-50'
              "
              class="flex items-center hover:text-primary item-list-custom p-1 rounded-lg hover:fill-primary space-x-2 transition-all ease-in-out duration-500"
            >
              <div
                :class="
                  routeName === 'domestic-shipments' ? 'fill-primary' : ''
                "
                class="transition-colors ease-in-out duration-300 shadow-softxl mr-2 flex h-10 w-10 items-center justify-center rounded-lg bg-center text-center p-2"
              >
                <IconDomesticRoad />
              </div>
              <span>{{ $t("nav.domestic-road") }}</span>
            </div>
          </RouterLink>
          <RouterLink
            v-if="
              authStore.accountPermissions.allowedAny([KPN.STRONGO_ENABLED])
            "
            :to="{ name: 'strongo-shipments' }"
            @click="close"
            class=""
          >
            <div
              :class="
                routeName === 'strongo-shipments'
                  ? 'active-menu-item text-primary bg-gray-50'
                  : '  text-secondary hover:bg-gray-50'
              "
              class="flex items-center hover:text-primary item-list-custom p-1 rounded-lg hover:fill-primary space-x-2 transition-all ease-in-out duration-500"
            >
              <div
                :class="routeName === 'strongo-shipments' ? 'fill-primary' : ''"
                class="transition-colors ease-in-out duration-300 shadow-softxl mr-2 flex h-10 w-10 items-center justify-center rounded-lg bg-center text-center p-2"
              >
                <IconStrongo />
              </div>
              <span>Strongo</span>
            </div>
          </RouterLink>
          <RouterLink
            v-if="authStore.accountPermissions.allowedAny([KPN.OCEAN_ENABLED])"
            :to="{ name: 'ocean' }"
            @click="close"
            class=""
          >
            <div
              :class="
                routeName === 'ocean'
                  ? 'active-menu-item text-primary bg-gray-50'
                  : '  text-secondary hover:bg-gray-50'
              "
              class="flex items-center hover:text-primary item-list-custom p-1 rounded-lg hover:fill-primary space-x-2 transition-all ease-in-out duration-500"
            >
              <div
                :class="routeName === 'ocean' ? 'fill-primary' : ''"
                class="transition-colors ease-in-out duration-300 shadow-softxl mr-2 flex h-10 w-10 items-center justify-center rounded-lg bg-center text-center p-2"
              >
                <IconOcean />
              </div>
              <span>{{ $t("nav.ocean") }}</span>
            </div>
          </RouterLink>
          <RouterLink
            v-if="authStore.accountPermissions.allowedAny([KPN.AIR_ENABLED])"
            :to="{ name: 'air' }"
            @click="close"
            class=""
          >
            <div
              :class="
                routeName === 'air'
                  ? 'active-menu-item text-primary bg-gray-50'
                  : '  text-secondary hover:bg-gray-50'
              "
              class="flex items-center hover:text-primary item-list-custom p-1 rounded-lg hover:fill-primary space-x-2 transition-all ease-in-out duration-500"
            >
              <div
                :class="routeName === 'air' ? 'fill-primary' : ''"
                class="transition-colors ease-in-out duration-300 shadow-softxl mr-2 flex h-10 w-10 items-center justify-center rounded-lg bg-center text-center p-2"
              >
                <IconAir />
              </div>
              <span>{{ $t("nav.air") }}</span>
            </div>
          </RouterLink>
        </div>
      </template>
      <div class="bg-indigo-lightest p-2 mt-3 border-t border-grey-darkest border-solid"></div>

      <RouterLink
        v-if="authStore.accountPermissions.allowedAny([KPN.ACTIVITYLOG_ENABLED])"
        :to="{ name: 'activity-log' }"
        @click="close"
        class=""
      >
        <div :class="routeName === 'activity-log'
              ? 'active-menu-item text-primary'
              : '  text-secondary'"
          class="text-secondary hover:bg-gray-50 flex items-center hover:text-primary item-list-custom p-1 rounded-lg hover:fill-primary space-x-2 transition-all ease-in-out duration-500"
        >
          <div :class="routeName === 'activity-log' ? 'fill-primary' : ''"
            class="transition-colors ease-in-out duration-300 shadow-softxl mr-2 flex h-10 w-10 items-center justify-center rounded-lg bg-center text-center p-2"
          >
            <IconActivityLog />
          </div>
          <span>{{ $t("nav.activity-log") }}</span>
        </div>
      </RouterLink>

      <RouterLink
        v-if="authStore.accountPermissions.allowedAny([KPN.ONECLICKDOCUMENTATION_ENABLED])"
        :to="{ name: 'oneclick-documentation' }"
        @click="close"
        :class="routeName === 'oneclick-documentation' ? 'active-menu-item text-primary stroke-primary' : 'stroke-text'"
        class="flex items-center hover:text-primary item-list-custom mt-3 hover:stroke-primary space-x-3 py-5 pl-3 border-t border-grey-darkest border-solid"
      >
        <IconUserManual />
        <span>Documentation</span>
      </RouterLink>
    </nav>
  </div>
</template>

<script setup lang="ts">
import { useRoute, useRouter } from "vue-router";
import { computed, ref } from "vue";
import { useAuthStore } from "@/stores/auth";
import { useSidebarSectionsStore } from "@/stores/sidebarSections";
import { KPN } from "@/types/permissions/KPN";
import IconUsers from "@/components/svg_icons/IconUsers.vue";
import IconRoles from "@/components/svg_icons/IconRoles.vue";
import IconCompanies from "@/components/svg_icons/IconCompanies.vue";
import IconContacts from "@/components/svg_icons/IconContacts.vue";
import IconIssuedToKlg from "@/components/svg_icons/IconIssuedToKlg.vue";
import IconIssuedByKlg from "@/components/svg_icons/IconIssuedByKlg.vue";
import IconWarehousingReception from "@/components/svg_icons/IconWarehousingReception.vue";
import IconWarehousingOrder from "@/components/svg_icons/IconWarehousingOrder.vue";
import IconWarehousingSimplifyReception from "@/components/svg_icons/IconWarehousingSimplifyReception.vue";
import IconWarehousingSimplifyOrder from "@/components/svg_icons/IconWarehousingSimplifyOrder.vue";
import IconDomesticRoad from "@/components/svg_icons/IconDomesticRoad.vue";
import IconInternationalRoad from "@/components/svg_icons/IconInternationalRoad.vue";
import IconOcean from "@/components/svg_icons/IconOcean.vue";
import IconAir from "@/components/svg_icons/IconAir.vue";
import IconActivityLog from "@/components/svg_icons/IconActivityLog.vue";
import IconUserManual from "@/components/svg_icons/IconUserManual.vue";
import IconStrongo from "@/components/svg_icons/IconStrongo.vue";
import IconOpenSection from "@/components/svg_icons/IconOpenSection.vue";
import IconAi from "@/components/svg_icons/IconAi.vue";
import IconAiChat from "@/components/svg_icons/IconAiChat.vue";
import IconCleoDocuments from "@/components/svg_icons/IconCleoDocuments.vue";
import IconCleoHistory from "@/components/svg_icons/IconCleoHistory.vue";
import IconClientCleoHistory from "@/components/svg_icons/IconClientCleoHistory.vue";
import IconCleoInsights from "@/components/svg_icons/IconCleoInsights.vue";
import IconCleoLimits from "@/components/svg_icons/IconCleoLimits.vue";

const route = useRoute();

const routeName = computed(() => {
  return route.name;
});

const authStore = useAuthStore();
const sidebarStore = useSidebarSectionsStore();
const emit = defineEmits(["update:modelValue"]);

const isSiteAdminOpen = computed(() =>
  sidebarStore.getSectionState("site_admin"),
);
const isTransportSiteConfigOpen = computed(() =>
  sidebarStore.getSectionState("transport_site_configuration"),
);
const isEtransportOpen = computed(() =>
  sidebarStore.getSectionState("etransport"),
);
const isWarehousingSiteConfigOpen = computed(() =>
  sidebarStore.getSectionState("warehousing_site_configuration"),
);
const isSiteConfigurationOpen = computed(() =>
  sidebarStore.getSectionState("site_configuration"),
);
const isAnnouncementsOpen = computed(() =>
  sidebarStore.getSectionState("announcements"),
);
const isAccessTokensOpen = computed(() => sidebarStore.getSectionState("krakend"));
const isAiOpen = computed(() => sidebarStore.getSectionState("ai"));
const isClientDocumentationOpen = computed(() =>
  sidebarStore.getSectionState("client_documentation"),
);
const isApplicationsApiOpen = computed(() =>
  sidebarStore.getSectionState("applications_api"),
);
const isOrderEntryOpen = computed(() =>
  sidebarStore.getSectionState("order_entry"),
);
const isKlgUsersOpen = computed(() =>
  sidebarStore.getSectionState("klg_users"),
);
const isClientsOpen = computed(() => sidebarStore.getSectionState("clients"));
const isErpOpen = computed(() => sidebarStore.getSectionState("erp"));
const isBusinessLinesOpen = computed(() =>
  sidebarStore.getSectionState("business_lines"),
);

const toggleSiteAdmin = () => {
  sidebarStore.toggleSection("site_admin");
};

const toggleTransportSiteConfig = () => {
  sidebarStore.toggleSection("transport_site_configuration");
};

const toggleEtransport = () => {
  sidebarStore.toggleSection("etransport");
};

const toggleWarehousingSiteConfig = () => {
  sidebarStore.toggleSection("warehousing_site_configuration");
};

const toggleSiteConfiguration = () => {
  sidebarStore.toggleSection("site_configuration");
};

const toggleAnnouncements = () => {
  sidebarStore.toggleSection("announcements");
};

const toggleAccessTokens = () => {
  sidebarStore.toggleSection("krakend");
};

const toggleAi = () => {
  sidebarStore.toggleSection("ai");
};

const toggleClientDocumentation = () => {
  sidebarStore.toggleSection("client_documentation");
};

const toggleApplicationsApi = () => {
  sidebarStore.toggleSection("applications_api");
};

const toggleOrderEntry = () => {
  sidebarStore.toggleSection("order_entry");
};

const toggleKlgUsers = () => {
  sidebarStore.toggleSection("klg_users");
};

const toggleClients = () => {
  sidebarStore.toggleSection("clients");
};

const toggleErp = () => {
  sidebarStore.toggleSection("erp");
};

const toggleBusinessLines = () => {
  sidebarStore.toggleSection("business_lines");
};

const close = () => {
  // console.log('minus');
  if (window.innerWidth < 1025) {
    emit("update:modelValue", false);
    // console.log('minuus');
    document.body.classList.remove("lock_body_scroll");
  }
};
</script>
